import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { ScheduleBlockRuleEntity } from './schedule-block-rule.entity'

export class ScheduleBlockRulesRepository extends BaseRepository<ScheduleBlockRuleEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/' + 'schedule-block-rules', token, cache)
    }
}
